RivalIQ.apps.PostRegistration.module('controller', function (controller, App, Backbone, Marionette, $, _) {

    'use strict';

    const Controller = Marionette.Controller.extend({

        start: function (options) {
            const me = this;

            me.options = _.extend({}, options);

            me.showCompanies();
            RivalIQ.execute('tracking:push:auth', 'V3PostRegistrationStarted');
        },

        showCompanies: function () {
            App.mainRegion.show(new App.views.CompaniesPage());
            RivalIQ.execute('tracking:push:auth', 'V3PostRegistrationViewedCompanies');
        }

    });

    controller.addInitializer(function (options) {
        const controller = new Controller();
        controller.start(options);
    });
});
